import * as React from 'react'
import { Navbar, Nav, NavItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

import MeQuery from './queries/MeQuery'
import { UserRole } from '../graphql/queries/me'
import { removeToken } from '../utils/auth'

const AppNavbar: React.SFC = () => (
  <MeQuery>
    {({ loading, data, client }) => {
      const isAdmin =
        data != null && data.user.roles.indexOf(UserRole.ADMIN) !== -1

      return (
        <Navbar>
          <Navbar.Header>
            <Navbar.Brand>Dlužníček</Navbar.Brand>
          </Navbar.Header>
          <Nav>
            <LinkContainer to="/my-loans">
              <NavItem eventKey={2}>Mé půjčky</NavItem>
            </LinkContainer>
            {isAdmin && (
              <LinkContainer to="/loans" exact={true}>
                <NavItem eventKey={1}>Půjčky</NavItem>
              </LinkContainer>
            )}
            {isAdmin && (
              <LinkContainer to="/users">
                <NavItem eventKey={2}>Uživatelé</NavItem>
              </LinkContainer>
            )}
          </Nav>
          <Nav pullRight={true}>
            {data != null && <NavItem>{data.user.name}</NavItem>}
            <NavItem
              eventKey={1}
              onClick={() => {
                removeToken()
                client.resetStore()
              }}
            >
              Odhlásit se
            </NavItem>
          </Nav>
        </Navbar>
      )
    }}
  </MeQuery>
)

export default AppNavbar



// WEBPACK FOOTER //
// ./src/components/Navbar.tsx